// extracted by mini-css-extract-plugin
export default {"footnotes":"Footnotes-module__footnotes__XNV9NTk"};